import React from 'react'
import { LuArrowRight, LuSparkles } from 'react-icons/lu'
import './CtaBanner.css'
import { Link } from 'react-router-dom'

const CtaBanner: React.FC<any> = () => {
  return (
    <section>
      <div className="position-relative overflow-hidden p-4 p-md-5" style={{ borderRadius: 20, background: 'linear-gradient(135deg, #D93D6A 0%, #FA5A84 50%, #FF8AAD 100%)' }}>
        <div className="position-relative" style={{ zIndex: 1 }}>
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-md-between">
            <div className="d-flex align-items-center">
              <div className="d-none d-md-flex align-items-center justify-content-center mr-4 flex-shrink-0" style={{ width: 56, height: 56, backgroundColor: 'rgba(255, 255, 255, 0.18)', borderRadius: 16 }}>
                <LuSparkles className="text-white" size={26} />
              </div>

              <div>
                <h2 className="cta-title font-weight-bold text-white mb-0">Saiba como iniciar a busca pelo seu doador ideal</h2>
                <p className="cta-copy mb-0 mt-1 text-white" style={{ opacity: 0.85 }}>Nossos especialistas estão prontos para te guiar em cada etapa do processo.</p>
              </div>
            </div>

            <Link to="/" target="_blank">
              <button type="button" className="btn btn-light rounded-pill px-4 py-2 mt-4 mt-md-0 d-inline-flex align-items-center font-weight-bold" style={{ color: '#FA5A84', flexShrink: 0 }}>
                Iniciar agora
                <LuArrowRight className="ml-2" size={16} />
              </button>
            </Link>
          </div>
        </div>

        <div className="position-absolute rounded-circle" style={{ width: 240, height: 240, right: -60, top: -80, backgroundColor: 'rgba(255, 255, 255, 0.08)' }} />
        <div className="position-absolute rounded-circle" style={{ width: 160, height: 160, right: 60, top: -60, backgroundColor: 'rgba(255, 255, 255, 0.07)' }} />
      </div>
    </section>
  )
}

export default CtaBanner
